import { schemaDocumentSnapshotQueryOptions, schemaQuerySnapshotQueryOptions } from '@valian/react-kitchen-sink'

import { collections } from '@/schema'

export const judicialRecordsQuery = () =>
  schemaQuerySnapshotQueryOptions({
    queryKey: ['judicialRecords'],
    factory: collections.judicialRecords,
    query: {
      name: 'All judicial records',
      orderBy: [['expirationDate', 'desc']],
    },
  })

export const judicialRecordQuery = (recordId: string) =>
  schemaDocumentSnapshotQueryOptions({
    queryKey: ['judicialRecords', recordId],
    factory: collections.judicialRecords,
    id: recordId,
  })
